import { DecoratorNode, SerializedLexicalNode, Spread } from "lexical";
import { DataRequest, markdownToDataRequest, renderDataRequest } from "../ai/autotext";
import { ReactNode } from "react";

export type SerializedDCVariableNode = Spread<
  {
    data: string;
    type: "dc-variable";
    version: 1;
  },
  SerializedLexicalNode
>;

export class DCVariableNode extends DecoratorNode<ReactNode> {
  __data: string;
  dataRequest: DataRequest;

  constructor(text: string, key?: string) {
    super(key);
    this.__data = text;
    this.dataRequest = markdownToDataRequest(text);
  }

  static getType(): string {
    return "dc-variable";
  }

  static clone(node: DCVariableNode): DCVariableNode {
    return new DCVariableNode(node.__data, node.__key);
  }

  createDOM(): HTMLElement {
    const element = document.createElement("span");
    element.className = "dc-variable";
    element.contentEditable = "false";
    return element;
  }

  updateDOM(): false {
    return false;
  }

  decorate(): ReactNode {
    return (
      <span className="dc-variable" contentEditable={false}>
        {renderDataRequest(markdownToDataRequest(this.__data))}
      </span>
    );
  }

  isInline(): true {
    return true;
  }

  isIsolated(): boolean {
    return true;
  }

  exportJSON(): SerializedDCVariableNode {
    return {
      type: "dc-variable",
      version: 1,
      data: this.__data,
    };
  }

  static importJSON(serializedNode: SerializedDCVariableNode): DCVariableNode {
    return new DCVariableNode(serializedNode.data);
  }
}

export function $createDCVariableNode(rawText: string): DCVariableNode {
  return new DCVariableNode(rawText);
}
